import { render, staticRenderFns } from "./vacancies.vue?vue&type=template&id=5ed836ed"
import script from "./vacancies.vue?vue&type=script&lang=js"
export * from "./vacancies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports